import { Tabs, TabsProps } from 'antd'
import YourBooks from './YourBooks'
import YourOrganizationBooks from './YourOrganizationBooks'
import UploadBook from './UploadBook'
import { useState } from 'react'

export const TABS = {
    YOUR_BOOKS_TAB: "1",
    YOUR_ORGANIZATION_TAB: "2",
    EDIT_BOOK_TAB: "3"
}


export default function KnowledgeBasePage() {
    const [selectedTab, setSelectedTab] = useState("1")

    const items: TabsProps["items"] = [
        {
            key: TABS.YOUR_BOOKS_TAB,
            label: "Your books",
            children: <YourBooks onTabChange={(selectedTab) => setSelectedTab(selectedTab)} />
        },
        {
            key: TABS.YOUR_ORGANIZATION_TAB,
            label: "Your Organization",
            children: <YourOrganizationBooks onTabChange={(selectedTab) => setSelectedTab(selectedTab)} />
        },
        {
            key: TABS.EDIT_BOOK_TAB,
            label: "Upload",
            children: <UploadBook onUploadComplete={() => { }} />
        }
    ]

    return (
        <div className='mx-0 px-5 py-5' style={{ height: "100vh", overflow: "auto" }}>
            <Tabs
                defaultActiveKey={selectedTab}
                items={items} />
        </div>
    )
}